<template>
  <div class="whatsnew-group">
    <div @click="toggleShow" class="title">
      <h2><i :class="{'fas fa-caret-right': !isShowing, 'fas fa-caret-down': isShowing}"></i> {{title}}</h2>
    </div>
    <hr />
    <div v-if="isShowing" class="pl-4">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.whatsnew-group .title {
  cursor: pointer;
  user-select: none;
}
</style>

<script>
export default {
  name: 'WhatsNewGroup',
  props: {
    title: String,
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowing: this.defaultOpen
    }
  },
  methods: {
    toggleShow() {
      this.isShowing = !this.isShowing;
    }
  }
}
</script>